import service from "../service";

export default {
  // 获取部门树
  getDepartmentTree(params: any): Promise<any> {
    return service({
      method: "GET",
      url: "/Department/GetDepartmentTree",
      params
    });
  },
  // 获取部门人员
  getDepartmentUser(params: any): Promise<any> {
    return service({
      method: "GET",
      url: "/Department/GetDepartmentUser",
      params
    });
  },
  // 获取角色列表
  getAllRole(): Promise<any> {
    return service({
      method: "GET",
      url: "/Department/getAllRole"
    });
  },
  // 新增角色
  createRole(data: any): Promise<any> {
    return service({
      method: "POST",
      url: "/Role/Post",
      data
    });
  },
  // 更新角色
  updateRole(data: any): Promise<any> {
    return service({
      method: "PUT",
      url: "/Role/Put",
      data
    });
  },
  // 删除角色
  deleteRole(params: any): Promise<any> {
    return service({
      method: "DELETE",
      url: "/Role/Delete",
      params
    });
  },
  // 更新人员角色
  updateUseRole(data: any): Promise<any> {
    return service({
      method: "PUT",
      url: "/Department/updateUseRole",
      data
    });
  },
  // 设置用户数据权限
  SetUserDataPermissions(params: any): Promise<any> {
    return service({
      method: "GET",
      url: "/Department/SetUserDataPermissions",
      params
    });
  },
  // 接口管理列表查询
  interfaceList(params: any, data: any): Promise<any> {
    return service({
      method: "POST",
      url: "/接口管理/列表查询",
      params,
      data
    });
  },
  // 新增接口
  interfaceCreate(data: any): Promise<any> {
    return service({
      method: "POST",
      url: "/接口管理/新增接口",
      data
    });
  },
  // 更新接口
  interfaceUpdate(data: any): Promise<any> {
    return service({
      method: "PUT",
      url: "/接口管理/更新接口",
      data
    });
  },
  // 删除接口
  interfaceDelete(params: any): Promise<any> {
    return service({
      method: "DELETE",
      url: "/接口管理/ID删除",
      params
    });
  },
  // 获取菜单树表格
  getMenuTreeTable(params: any): Promise<any> {
    return service({
      method: "GET",
      url: "/Permission/GetTreeTable",
      params
    });
  },
  // 更新菜单
  updateMenu(data: any): Promise<any> {
    return service({
      method: "PUT",
      url: "/Permission/Put",
      data
    });
  },
  // 新增菜单
  createMenu(data: any): Promise<any> {
    return service({
      method: "POST",
      url: "/Permission/Post",
      data
    });
  },
  // 删除菜单
  deleteMenu(params: any): Promise<any> {
    return service({
      method: "DELETE",
      url: "/Permission/Delete",
      params
    });
  },
  // 获取权限树
  getPermissionTree(): Promise<any> {
    return service({
      method: "GET",
      url: "/Permission/GetPermissionTree"
    });
  },
  // 根据角色ID获取已分配权限ID
  getPermissionIdByRoleId(params: any): Promise<any> {
    return service({
      method: "GET",
      url: "/Permission/GetPermissionIdByRoleId",
      params
    });
  },
  // 分配角色权限
  assignPermission(data: any): Promise<any> {
    return service({
      method: "POST",
      url: "/Permission/Assign",
      data
    });
  }
};
